// firebase-config.ts
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, Messaging } from "firebase/messaging";
import { Capacitor } from "@capacitor/core";

// Your Firebase config object (from Firebase Console)
const firebaseConfig = {
    apiKey: "AIzaSyA8FNm0c7AuBbwL5waVq6q0UoKGI7KRZpY",
    authDomain: "chat2s-e6493.firebaseapp.com",
    projectId: "chat2s-e6493",
    storageBucket: "chat2s-e6493.appspot.com",
    messagingSenderId: "480651435058",
    appId: "1:480651435058:web:914ba5ecbdc09ca7d1302b",
    //measurementId: "G-03K1PSRY5T"
};

const app = initializeApp(firebaseConfig);

// getMessaging() throws on environments the Firebase Web SDK doesn't support
// (notably iOS WKWebView inside a Capacitor native build). Native platforms
// get their FCM token via @capacitor-firebase/messaging instead (see
// Utils.GetFCMTokenNative in utils.ts), so this is never used there — skip
// initializing it to avoid a startup crash. Any web-only call site that uses
// `messaging` already only runs when Capacitor.isNativePlatform() is false.
let messagingInstance: Messaging | undefined;
if (!Capacitor.isNativePlatform()) {
    try {
        messagingInstance = getMessaging(app);
    } catch (e) {
        console.error("firebase getMessaging() unsupported in this environment:", e);
    }
}
export const messaging = messagingInstance as Messaging;
